import { Directive, OnInit, Input, Output, EventEmitter, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { isDefined } from '@fi-shared/utils/is-defined';
import { fiDebounce, findClosest } from '@fi-shared/utils';

@Directive({
    selector: '[fiBecomeVisible]',
    exportAs: 'fiBecomeVisible',
    standalone: false,
})
export class BecomeVisibleDirective implements OnInit, OnDestroy {
    @Input() fiBecomeVisibleHeight: string;
    @Output() fiBecomeVisible = new EventEmitter();
    @Output() fiBecomeInvisible = new EventEmitter();

    scrollCallback: () => void;
    private lastVisibilityResult: boolean = false;
    private scrollEventListener: () => void;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {
        this.scrollCallback = fiDebounce(() => {
            if (this.isVisible()) {
                if (this.lastVisibilityResult === false) {
                    this.lastVisibilityResult = true;
                    this.fiBecomeVisible.emit();
                }
            } else {
                if (this.lastVisibilityResult === true) {
                    this.lastVisibilityResult = false;
                    this.fiBecomeInvisible.emit();
                }
            }
        }, 100);
    }

    ngOnInit(): void {
        this.scrollEventListener = this.renderer.listen(
            findClosest(this.elementRef.nativeElement, '[fi-scroll-root]'),
            'scroll',
            this.scrollCallback,
        );
        this.scrollCallback();
    }

    isVisible(): boolean {
        return this.checkVisible(this.elementRef.nativeElement, this.fiBecomeVisibleHeight);
    }

    private checkVisible(elm: HTMLElement, size: string): boolean {
        const rect = elm.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        let minVisibleSize = 0;

        // with minimum height settings = "half" element should be scrolled to half of his own height
        // add here some other options or parting of percents/pixels if needed
        if (isDefined(size)) {
            switch (size) {
                case 'half':
                    const elementHeight = elm.offsetHeight;
                    minVisibleSize = (elementHeight > viewHeight ? viewHeight : elementHeight) / 2;
                    break;
            }
        }
        return !(rect.bottom < 0 || rect.top + minVisibleSize - viewHeight >= 0);
    }

    ngOnDestroy(): void {
        this.scrollEventListener();
    }
}
